function NRXaiDarkIcon({ height = '24', width = '24' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.09658 9.128L16.3027 22.1667H12.2107L3.00458 9.128H7.09658ZM7.09292 16.3697L9.13983 19.27L7.09475 22.1667H3L7.09292 16.3697ZM21.3333 3.45017V22.1667H17.9792V8.20033L21.3333 3.45017ZM21.3333 2L12.2107 14.9204L10.1637 12.021L17.2386 2H21.3333Z"
        fill="white"
      />
    </svg>
  );
}

export default NRXaiDarkIcon;
